const RECAPTCHA_SCRIPT_ID = 'google-recaptcha-v3'
let recaptchaLoadPromise

const getSiteKey = () => process.env.REACT_APP_RECAPTCHA_V3_SITE_KEY

const waitForRecaptcha = (resolve, reject) => {
    const startedAt = Date.now()
    const check = () => {
        if (window.grecaptcha && typeof window.grecaptcha.execute === 'function') {
            resolve(window.grecaptcha)
        } else if (Date.now() - startedAt >= 10000) {
            reject(new Error('Google reCAPTCHA v3 is unavailable'))
        } else {
            window.setTimeout(check, 50)
        }
    }
    check()
}

const loadRecaptcha = (siteKey) => {
    if (window.grecaptcha && typeof window.grecaptcha.execute === 'function') {
        return Promise.resolve(window.grecaptcha)
    }

    if (recaptchaLoadPromise) {
        return recaptchaLoadPromise
    }

    const existingScript = document.getElementById(RECAPTCHA_SCRIPT_ID)
    recaptchaLoadPromise = new Promise((resolve, reject) => {
        const waitForLoadedScript = () => {
            waitForRecaptcha(resolve, reject)
        }

        if (existingScript) {
            if (
                existingScript.dataset.loaded === 'true' ||
                existingScript.readyState === 'complete'
            ) {
                waitForLoadedScript()
                return
            }

            existingScript.addEventListener('load', waitForLoadedScript, { once: true })
            existingScript.addEventListener(
                'error',
                () => reject(new Error('Unable to load Google reCAPTCHA')),
                { once: true },
            )
            return
        }

        const script = document.createElement('script')
        script.id = RECAPTCHA_SCRIPT_ID
        script.src = `https://www.google.com/recaptcha/api.js?render=${encodeURIComponent(siteKey)}`
        script.async = true
        script.defer = true
        script.onload = () => {
            script.dataset.loaded = 'true'
            waitForLoadedScript()
        }
        script.onerror = () => reject(new Error('Unable to load Google reCAPTCHA'))
        document.head.appendChild(script)
    }).catch((error) => {
        recaptchaLoadPromise = undefined
        throw error
    })

    return recaptchaLoadPromise
}

export const initializeRecaptcha = () => {
    const siteKey = getSiteKey()
    if (!siteKey) {
        return Promise.reject(new Error('REACT_APP_RECAPTCHA_V3_SITE_KEY is not configured'))
    }
    return loadRecaptcha(siteKey)
}

export const getRecaptchaToken = async (action) => {
    const siteKey = getSiteKey()
    const recaptcha = await initializeRecaptcha()
    await new Promise((resolve) => recaptcha.ready(resolve))
    return recaptcha.execute(siteKey, { action })
}
